import permitIssuesService from '@/api/permit-issues-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const getDefaultFormItem = () => ({});

export const getDefaultPermitIssuesFilterParams = () => ({});

const state = {
  permitIssues: null,
  permitIssuesPagination: {},
  newPermitIssue: getDefaultFormItem(),
  permitIssueValidationErrors: {},
  permitIssuesFilterParams: getDefaultPermitIssuesFilterParams(),
};

const mutations = {
  SET_PERMIT_ISSUES(state, { data, meta }) {
    state.permitIssues = data;
    state.permitIssuesPagination = {
      current_page: meta.current_page,
      per_page: meta.per_page,
      total: meta.total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.permitIssuesFilterParams = params;
  },

  // STORE_PERMIT_ISSUE(state, permitIssue) {
  //   state.permitIssues = [...state.permitIssues, permitIssue];
  //   state.newPermitIssue = getDefaultFormItem();
  //   state.permitIssueValidationErrors = {};
  //   state.permitIssuesPagination.total += 1;
  // },

  SET_PERMIT_ISSUE_VALIDATION_ERRORS(state, validationErrors) {
    state.permitIssueValidationErrors = validationErrors;
  },

  RESET_PERMIT_ISSUES_VALIDATION_ERRORS(state) {
    state.permitIssueValidationErrors = {};
  },

  CLEAR_VALIDATION_ERRORS(state, field) {
    delete state.permitIssueValidationErrors[field];
  },
};

const actions = {
  fetchPermitIssues({ commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return permitIssuesService.getPage(params).then((res) => {
      commit('SET_PERMIT_ISSUES', res.data);
      return res.data;
    });
  },

  reportPermitIssue({ commit }, permitIssue) {
    return permitIssuesService
      .create(permitIssue)
      .then((res) => {
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('permit_issue_reported'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_PERMIT_ISSUE_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearPermitIssueValidationErrors({ commit }, field) {
    commit('CLEAR_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
